module.exports = __webpack_public_path__ + "static/media/massive_events.2d8f962b.svg";